import { useSelector } from 'react-redux';

import { selectCompany } from '@/domains/care/myAccount/company/selectors';
import { getPlatform } from '@/domains/core/settings/utils';
import { getVATType } from '@/domains/customerFinanceOperations/utils/getVATType';
import { CrossBorderCode } from '@/domains/productDelivery/services/msfCheckoutFunnel/interfaces';
import { useComputeXborderQuery } from '@/domains/productDiscovery/ProductPage/graphql/computeXborder/generated/computeXborder.query.generated';
import { SubjectedToVat } from '@/generated/graphql/types';
import { useDetail } from '@/productDiscovery/ProductPage/hooks/useDetail';

export type XBorderVat = 'zero' | 'nonDeductible' | 'none';

export const useXBorderVat = (): XBorderVat => {
  const company = useSelector(selectCompany);

  const {
    seller: { id: sellerId },
  } = useDetail();

  const {
    crossBorderVat: { vatStatus, isFraudSuspected, isLocalVat, subjectedToVat },
    zipCode,
  } = company;

  const [{ data }] = useComputeXborderQuery({
    pause: !zipCode || !vatStatus || !sellerId || isLocalVat === undefined,
    variables: {
      sellerId,
      isLocalVat: isLocalVat ?? false,
      vatStatus: vatStatus ?? '',
      eoriNumberValid: false,
      subjectedToVat: subjectedToVat === SubjectedToVat.YES,
      companyZipCode: zipCode ?? '',
      isFraudSuspected,
      platform: getPlatform().toUpperCase(),
    },
  });

  if (!data) return 'none';

  return getVATType(
    data.computeXborder.xborderVatTreatmentCode as CrossBorderCode,
  );
};
